<template>
  <div class="news-page">

    <!-- ═══════════════════ HERO — Paradigma (imagen lateral) ═══════════════════ -->
    <section class="news-hero">
      <div class="container hero-content">
        <div class="row align-items-center g-5">
          <div class="col-lg-6">
            <div class="hero-badge mb-3">
              <i class="fa-solid fa-arrows-spin me-2"></i>
              {{ $t('news.paradigm.title') }}
            </div>
            <h1 class="hero-title">{{ $t('news.title') }}</h1>
            <p class="hero-description" v-html="$t('news.paradigm.description')"></p>

            <!-- Aprèn 1.0 vs 2.0 comparison -->
            <div class="row g-3 mt-2">
              <div class="col-sm-6">
                <div class="compare-card compare-old">
                  <span class="compare-badge compare-badge-old">Aprèn 1.0</span>
                  <p class="compare-text">{{ $t('news.paradigm.old_desc') }}</p>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="compare-card compare-new">
                  <span class="compare-badge compare-badge-new">Aprèn 2.0</span>
                  <p class="compare-text">{{ $t('news.paradigm.new_desc') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 d-none d-lg-block">
            <div class="hero-image-wrapper">
              <img src="../assets/images/news1.jpg" alt="Novetats Aprèn" class="hero-image" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ═══════════════════ FONTS D'INFORMACIÓ — full-width gradient ═══════════════════ -->
    <section class="sources-fullwidth" id="sources">
      <div class="container">
        <div class="section-header">
          <div class="section-icon-wrap icon-light">
            <i class="fa-solid fa-database"></i>
          </div>
          <div>
            <h2 class="section-title section-title-light">{{ $t('news.sources.title') }}</h2>
            <p class="section-subtitle-light" v-html="$t('news.sources.description')"></p>
          </div>
        </div>

        <div class="sources-grid">
          <!-- PRISMA -->
          <div class="source-card">
            <div class="source-card-header source-prisma">
              <i class="fa-solid fa-graduation-cap source-icon"></i>
              <h3 class="source-card-title">{{ $t('news.sources.prisma') }}</h3>
            </div>
            <div class="source-card-body" v-html="$t('news.sources.prisma_desc')"></div>
          </div>
          <!-- DRAC -->
          <div class="source-card">
            <div class="source-card-header source-drac">
              <i class="fa-solid fa-medal source-icon"></i>
              <h3 class="source-card-title">{{ $t('news.sources.drac') }}</h3>
            </div>
            <div class="source-card-body" v-html="$t('news.sources.drac_desc')"></div>
          </div>
          <!-- UPCommons -->
          <div class="source-card">
            <div class="source-card-header source-upcommons">
              <i class="fa-solid fa-cloud-arrow-down source-icon"></i>
              <h3 class="source-card-title">{{ $t('news.sources.upcommons') }}</h3>
            </div>
            <div class="source-card-body" v-html="$t('news.sources.upcommons_desc')"></div>
          </div>
        </div>
      </div>
    </section>

    <div class="container main-content">

      <!-- ═══════════════════ FACETED NAVIGATION ═══════════════════ -->
      <section class="content-section" id="facets">
        <div class="section-header">
          <div class="section-icon-wrap icon-teal">
            <i class="fa-solid fa-filter"></i>
          </div>
          <div>
            <h2 class="section-title">{{ $t('news.facets.title') }}</h2>
          </div>
        </div>

        <p class="body-text mb-4" v-html="$t('news.facets.description')"></p>

        <div class="facets-grid">
          <div class="facet-card">
            <div class="facet-card-header facet-header-blue">
              <i class="fa-solid fa-list-ul facet-icon"></i>
              <h3 class="facet-card-title">{{ $t('news.facets.activities.title') }}</h3>
            </div>
            <p class="facet-desc">{{ $t('news.facets.activities.desc') }}</p>
            <div class="facet-img-wrap">
              <img src="../assets/images/news-facet1.png" alt="Activities Facet" class="facet-img" />
            </div>
          </div>
          <div class="facet-card">
            <div class="facet-card-header facet-header-cyan">
              <i class="fa-solid fa-sliders facet-icon"></i>
              <h3 class="facet-card-title">{{ $t('news.facets.filters.title') }}</h3>
            </div>
            <p class="facet-desc">{{ $t('news.facets.filters.desc') }}</p>
            <div class="facet-img-wrap">
              <img src="../assets/images/news-facet2.png" alt="Filters Facet" class="facet-img" />
            </div>
          </div>
          <div class="facet-card">
            <div class="facet-card-header facet-header-indigo">
              <i class="fa-solid fa-sitemap facet-icon"></i>
              <h3 class="facet-card-title">{{ $t('news.facets.context.title') }}</h3>
            </div>
            <p class="facet-desc">{{ $t('news.facets.context.desc') }}</p>
            <div class="facet-img-wrap">
              <img src="../assets/images/news-facet3.png" alt="Context Facet" class="facet-img" />
            </div>
          </div>
        </div>
      </section>

    </div>

    <!-- ═══════════════════ AI — full-width grey gradient ═══════════════════ -->
    <section class="ai-fullwidth" id="ai">
      <div class="container">
        <div class="section-header">
          <div class="section-icon-wrap icon-indigo">
            <i class="fa-solid fa-brain"></i>
          </div>
          <div>
            <h2 class="section-title">{{ $t('news.ai_integration.title') }}</h2>
            <p class="ai-intro-text" v-html="$t('news.ai_integration.description')"></p>
          </div>
        </div>

        <!-- 3 cards — una per funcionalitat IA -->
        <div class="ai-cards-grid">

          <!-- Card 1: Resum setmanal -->
          <div class="ai-func-card">
            <div class="ai-func-img-wrap">
              <img :src="require('@/assets/images/ia-icon-resum.png')" alt="IA Weekly Summary" class="ai-func-img" />
            </div>
            <div class="ai-func-header ai-func-header-1">
              <i class="fa-solid fa-newspaper me-2"></i>
              {{ $t('news.ai_integration.features.weekly_summary.title') }}
            </div>
            <div class="ai-func-body">
              <p>{{ $t('news.ai_integration.features.weekly_summary.desc') }}</p>
            </div>
            <div class="ai-func-footer">
              <span class="ai-func-example-label">{{ $t('news.ai_integration.features.example_label') }}</span>
              <a :href="$t('news.ai_integration.features.weekly_summary.example_link')" target="_blank" class="ai-func-link">
                {{ $t('news.ai_integration.features.weekly_summary.example_link') }}
                <i class="fa-solid fa-arrow-up-right-from-square ms-1"></i>
              </a>
            </div>
          </div>

          <!-- Card 2: Highlights de documents -->
          <div class="ai-func-card">
            <div class="ai-func-img-wrap">
              <img :src="require('@/assets/images/ia-icon-highlight.png')" alt="IA Document Highlights" class="ai-func-img" />
            </div>
            <div class="ai-func-header ai-func-header-2">
              <i class="fa-solid fa-file-lines me-2"></i>
              {{ $t('news.ai_integration.features.highlights.title') }}
            </div>
            <div class="ai-func-body">
              <p>{{ $t('news.ai_integration.features.highlights.desc') }}</p>
            </div>
            <div class="ai-func-footer">
              <span class="ai-func-example-label">{{ $t('news.ai_integration.features.example_label') }}</span>
              <a :href="$t('news.ai_integration.features.highlights.example_link')" target="_blank" class="ai-func-link">
                {{ $t('news.ai_integration.features.highlights.example_link') }}
                <i class="fa-solid fa-arrow-up-right-from-square ms-1"></i>
              </a>
            </div>
          </div>

          <!-- Card 3: Radar d'innovació TFG/TFM -->
          <div class="ai-func-card">
            <div class="ai-func-img-wrap">
              <img :src="require('@/assets/images/ia-icon-radar.png')" alt="IA Innovation Radar" class="ai-func-img" />
            </div>
            <div class="ai-func-header ai-func-header-3">
              <i class="fa-solid fa-chart-bubble me-2"></i>
              {{ $t('news.ai_integration.features.radar.title') }}
            </div>
            <div class="ai-func-body">
              <p>{{ $t('news.ai_integration.features.radar.desc') }}</p>
            </div>
            <div class="ai-func-footer">
              <span class="ai-func-example-label">{{ $t('news.ai_integration.features.example_label') }}</span>
              <a :href="$t('news.ai_integration.features.radar.example_link')" target="_blank" class="ai-func-link">
                {{ $t('news.ai_integration.features.radar.example_link') }}
                <i class="fa-solid fa-arrow-up-right-from-square ms-1"></i>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- ═══════════════════ DOCUMENTACIÓ — full-width footer strip ═══════════════════ -->
    <section class="doc-fullwidth pb-5" id="documentation">
      <div class="container mt-5">
        
        <a href="https://apren.upc.edu/doc/harvester.html" target="_blank" class="doc-link-card">
          <div class="doc-link-icon">
            <i class="fa-solid fa-book-open"></i>
          </div>
          <div class="doc-link-body">
            <h3 class="doc-link-title">{{ $t('news.documentation.harvester.title') }}</h3>
            <p class="doc-link-desc">{{ $t('news.documentation.harvester.desc') }}</p>
          </div>
          <div class="doc-link-arrow">
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
          </div>
        </a>
      </div>
    </section>

  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import store from "@/store";

export default defineComponent({
  name: 'NewsView',
  setup() {
    const route = useRoute();

    onMounted(async () => {
      await store.dispatch('updateSearchSelected', "Tots");
      await store.dispatch('updateBackgroundImage', {
        view: route.name,
        url: require('@/assets/images/sections/banner-blue.webp')
      });
    });

    return {};
  }
});
</script>

<style scoped>
/* ════════════════════════════════════════════════
   DESIGN TOKENS — PALETA APREN AZUL (idéntica a AboutView)
════════════════════════════════════════════════ */
.news-page {
  --apren-900: #0c2340;
  --apren-800: #0d3160;
  --apren-700: #0a4a8a;
  --apren-600: #007BC1;
  --apren-500: #0a66c2;
  --apren-400: #1e90d4;
  --apren-300: #38b6e8;
  --apren-200: #a8d8f0;
  --apren-100: #dff0fb;

  --text-primary: #0c2340;
  --text-secondary: #4a6278;
  --text-muted: #7a93a8;

  --surface: #ffffff;
  --border: #d6e8f5;

  font-family: 'Roboto', Helvetica, serif;
  font-weight: 300;
  font-size: 18px;
  line-height: 28px;

  background: transparent;
  min-height: 100vh;
}

/* ════════════════════════════════════════════════
   HERO — sin fondo, hereda el de Aprèn
════════════════════════════════════════════════ */
.news-hero {
  background: transparent;
  padding: 2rem 0 1.5rem;
}

.hero-content {
  position: relative;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  background: var(--apren-100);
  border: 1px solid var(--apren-200);
  color: var(--apren-700);
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.35rem 1rem;
  border-radius: 50px;
}

.hero-title {
  font-size: clamp(1.8rem, 3.5vw, 2.6rem);
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.15;
  margin: 0 0 1.25rem;
  border: none;
  padding: 0;
  background: none;
}

.hero-description {
  font-size: 18px;
  font-weight: 300;
  line-height: 28px;
  color: var(--text-secondary);
  margin: 0;
  white-space: pre-line;
}

.hero-image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-image {
  width: 100%;
  max-width: 500px;
  border-radius: 20px;
  box-shadow: 0 16px 48px rgba(10, 102, 194, 0.18);
  object-fit: cover;
}

/* Comparación Aprèn 1.0 / 2.0 */
.compare-card {
  border-radius: 12px;
  padding: 1rem 1.1rem;
  height: 100%;
}

.compare-old {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
}

.compare-new {
  background: var(--apren-100);
  border: 1px solid var(--apren-200);
}

.compare-badge {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  padding: 0.2rem 0.65rem;
  border-radius: 50px;
  margin-bottom: 0.6rem;
}

.compare-badge-old {
  background: #e2e8f0;
  color: #64748b;
}

.compare-badge-new {
  background: var(--apren-500);
  color: #fff;
}

.compare-text {
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  color: var(--text-secondary);
  margin: 0;
}

/* ════════════════════════════════════════════════
   FONTS D'INFORMACIÓ — full-width blue gradient
   (misma técnica que objectives en AboutView)
════════════════════════════════════════════════ */
.sources-fullwidth {
  background: linear-gradient(135deg, #0c2340 0%, #0d3d6b 45%, #0a66c2 100%);
  padding: 3rem 0 3.5rem;
  /* Escapar el padding del container-fluid padre */
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  padding-left: calc(50vw - 50%);
  padding-right: calc(50vw - 50%);
  margin-bottom: 0;
  box-sizing: border-box;
}

.sources-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;
  margin-top: 0.5rem;
}

.source-card {
  background: rgba(255, 255, 255, 0.10);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.28s ease;
}

.source-card:hover {
  background: rgba(255, 255, 255, 0.16);
  transform: translateY(-4px);
}

.source-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
}

.source-prisma   { background: rgba(255,255,255,0.15); border-bottom: 1px solid rgba(255,255,255,0.20); }
.source-drac     { background: rgba(255,255,255,0.12); border-bottom: 1px solid rgba(255,255,255,0.20); }
.source-upcommons{ background: rgba(255,255,255,0.10); border-bottom: 1px solid rgba(255,255,255,0.20); }

.source-icon {
  font-size: 1.2rem;
  color: rgba(255,255,255,0.90);
}

.source-card-title {
  font-size: 1rem;
  font-weight: 700;
  color: white;
  margin: 0;
  line-height: 1.3;
}

.source-card-body {
  padding: 1rem 1.25rem 1.25rem;
  font-size: 16px;
  font-weight: 300;
  line-height: 26px;
  color: rgba(255, 255, 255, 0.88);
}

/* ════════════════════════════════════════════════
   SECTION COMMON (idéntico a AboutView)
════════════════════════════════════════════════ */
.main-content {
  padding-top: 2.5rem;
}

.content-section {
  margin-bottom: 3rem;
}

.section-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.75rem;
}

.section-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, #007BC1, #0a66c2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: white;
  flex-shrink: 0;
  box-shadow: 0 6px 18px rgba(10, 102, 194, 0.30);
}

.section-icon-wrap.icon-light {
  background: rgba(255, 255, 255, 0.20);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.35);
  box-shadow: none;
}

.section-icon-wrap.icon-teal {
  background: linear-gradient(135deg, #0891b2, #0ea5e9);
  box-shadow: 0 6px 18px rgba(8, 145, 178, 0.30);
}

.section-icon-wrap.icon-indigo {
  background: linear-gradient(135deg, #0c2340, #0a4a8a);
  box-shadow: 0 6px 18px rgba(12, 35, 64, 0.30);
}

.section-title {
  font-size: 1.45rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.2rem;
  line-height: 1.3;
}

.section-title-light {
  color: #ffffff;
}

.section-subtitle-light {
  font-size: 18px;
  font-weight: 300;
  line-height: 28px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0.25rem 0 0;
}

.body-text {
  font-size: 18px;
  font-weight: 300;
  line-height: 28px;
  color: var(--text-secondary);
  white-space: pre-line;
}

/* ════════════════════════════════════════════════
   FACETS GRID — 3 columnas con imagen
════════════════════════════════════════════════ */
.facets-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;
}

.facet-card {
  background: white;
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.28s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
}

.facet-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 16px 36px rgba(10, 102, 194, 0.12);
}

.facet-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
}

.facet-header-blue   { background: linear-gradient(135deg, #007BC1, #0a66c2); }
.facet-header-cyan   { background: linear-gradient(135deg, #0891b2, #06b6d4); }
.facet-header-indigo { background: linear-gradient(135deg, #0c2340, #0a4a8a); }

.facet-icon {
  font-size: 1.1rem;
  color: rgba(255,255,255,0.9);
}

.facet-card-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: white;
  margin: 0;
  line-height: 1.3;
}

.facet-desc {
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  color: var(--text-muted);
  padding: 0.85rem 1.25rem 0.5rem;
  margin: 0;
  flex-shrink: 0;
}

.facet-img-wrap {
  flex: 1;
  padding: 0 1rem 1rem;
  overflow: hidden;
}

.facet-img {
  width: 100%;
  height: 420px;
  object-fit: cover;
  object-position: top;
  border-radius: 8px;
  border: 1px solid var(--border);
}

/* ════════════════════════════════════════════════
   AI — full-width grey gradient
   Misma técnica que sources-fullwidth pero gris suave
════════════════════════════════════════════════ */
.ai-fullwidth {
  background: linear-gradient(135deg, #edf0f4 0%, #e4e9f0 45%, #dae2ec 100%);
  padding: 3rem 0 3.5rem;
  /* Escapar el padding del container-fluid padre */
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  padding-left: calc(50vw - 50%);
  padding-right: calc(50vw - 50%);
  margin-bottom: 0;
  box-sizing: border-box;
}

.ai-fullwidth .section-title {
  color: var(--text-primary);
}

.ai-fullwidth .body-text {
  color: var(--text-secondary);
}

.ai-intro-text {
  font-size: 18px;
  font-weight: 300;
  line-height: 28px;
  color: var(--text-secondary);
  margin: 0.4rem 0 0;
}

/* ════════════════════════════════════════════════
   AI FUNC CARDS GRID — 3 columnes iguals
════════════════════════════════════════════════ */
.ai-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;
  margin-top: 1.5rem;
}

.ai-func-card {
  background: white;
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.28s ease;
  box-shadow: 0 4px 14px rgba(10, 102, 194, 0.08);
}

.ai-func-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 16px 36px rgba(10, 102, 194, 0.14);
}

/* Zona superior per a la imatge */
.ai-func-img-wrap {
  flex-shrink: 0;
  height: 200px;
  overflow: hidden;
  background: white;
  border-bottom: 1px solid var(--border);
}

.ai-func-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.ai-func-card:hover .ai-func-img {
  transform: scale(1.08);
}

/* Cabecera de color — una per funcionalitat */
.ai-func-header {
  display: flex;
  align-items: center;
  padding: 0.9rem 1.25rem;
  font-family: 'Roboto', Helvetica, serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: white;
}

.ai-func-header-1 { background: linear-gradient(135deg, #007BC1, #0a66c2); }
.ai-func-header-2 { background: linear-gradient(135deg, #0891b2, #06b6d4); }
.ai-func-header-3 { background: linear-gradient(135deg, #0c2340, #0a4a8a); }

/* Cos del card */
.ai-func-body {
  flex: 1;
  padding: 1rem 1.25rem 0.5rem;
  font-family: 'Roboto', Helvetica, serif;
  font-size: 18px;
  font-weight: 300;
  line-height: 28px;
  color: var(--text-secondary);
}

.ai-func-body p {
  margin: 0;
}

/* Footer amb link "Exemple" */
.ai-func-footer {
  padding: 0.85rem 1.25rem 1.1rem;
  border-top: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.ai-func-example-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-muted);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ai-func-link {
  font-family: 'Roboto', Helvetica, serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--apren-500);
  text-decoration: none;
  word-break: break-all;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  transition: color 0.2s ease;
}

.ai-func-link:hover {
  color: var(--apren-400);
  text-decoration: underline;
}

@media (max-width: 992px) {
  .ai-cards-grid {
    grid-template-columns: 1fr;
  }
}

/* ════════════════════════════════════════════════
   AI FEATURE CARD
════════════════════════════════════════════════ */
.ai-feature-card {
  background: white;
  border: 1px solid var(--border);
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.28s ease;
  box-shadow: 0 4px 16px rgba(10, 102, 194, 0.08);
}

.ai-feature-card:hover {
  box-shadow: 0 12px 28px rgba(10, 102, 194, 0.14);
}

.ai-feature-header {
  background: linear-gradient(135deg, #0c2340, #0a4a8a);
  color: white;
  font-family: 'Roboto', Helvetica, serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  padding: 0.9rem 1.25rem;
  display: flex;
  align-items: center;
}

.ai-feature-body {
  padding: 1.25rem 1.4rem 1.4rem;
  font-family: 'Roboto', Helvetica, serif;
  font-size: 18px;
  font-weight: 300;
  line-height: 28px;
  color: var(--text-secondary);
}

/* ════════════════════════════════════════════════
   DOCUMENTATION — strip al fondo
════════════════════════════════════════════════ */
.doc-fullwidth {
  background: transparent;
  padding-top: 0;
}

.doc-link-card {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  background: white;
  border: 1px solid var(--border);
  border-left: 4px solid var(--apren-500);
  border-radius: 14px;
  padding: 1.25rem 1.5rem;
  text-decoration: none;
  transition: all 0.25s ease;
  color: inherit;
}

.doc-link-card:hover {
  transform: translateX(6px);
  box-shadow: 0 8px 24px rgba(10, 102, 194, 0.14);
  border-left-color: var(--apren-400);
  text-decoration: none;
  color: inherit;
}

.doc-link-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, #007BC1, #0a66c2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: white;
  flex-shrink: 0;
  box-shadow: 0 6px 18px rgba(10, 102, 194, 0.30);
}

.doc-link-body {
  flex: 1;
}

.doc-link-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.25rem;
  line-height: 1.3;
}

.doc-link-desc {
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  color: var(--text-muted);
  margin: 0;
}

.doc-link-arrow {
  color: var(--apren-400);
  font-size: 1rem;
  flex-shrink: 0;
}

/* ════════════════════════════════════════════════
   RESPONSIVE
════════════════════════════════════════════════ */
@media (max-width: 992px) {
  .sources-grid,
  .facets-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .news-hero {
    padding: 1.5rem 0 1rem;
  }

  .hero-title {
    font-size: 1.7rem;
  }

  .sources-fullwidth {
    padding-top: 2rem;
    padding-bottom: 2.5rem;
  }

  .facet-img {
    height: 250px;
  }
}
</style>
